import { cn } from "../utils/tailwindcss"

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  preventUpdate?: boolean
  hoverEvent?: string
  outEvent?: string
  clickEvent?: string
  /** When true, the WebGL small button shows an icon (from SVG child) instead of text. Set data-icon on the button. */
  icon?: boolean
  /** Raster resolution for the icon texture (e.g. 32). Optional; only used when icon is true. */
  iconSize?: number
  children: React.ReactNode
}

export function SmallButton({
  preventUpdate,
  hoverEvent,
  outEvent,
  clickEvent,
  icon,
  iconSize,
  children,
  className,
  ...rest
}: Props) {
  return (
    <button
      data-animation="webgl-small-button"
      className={cn(
        "h-6 w-20 leading-0 tracking-widest text-neutral-400 uppercase cursor-pointer text-[14px]",
        className,
      )}
      {...(preventUpdate && { "data-animation-prevent-update": true })}
      {...(clickEvent && { "data-click-event": clickEvent })}
      {...(hoverEvent && { "data-hover-event": hoverEvent })}
      {...(outEvent && { "data-out-event": outEvent })}
      {...(icon && { "data-icon": true })}
      {...(iconSize != null && { "data-icon-size": iconSize })}
      {...rest}
    >
      {children}
    </button>
  )
}
